// Paleta institucional Elecom — fuente única de verdad para los tokens de color.
// Se centraliza acá para evitar que Layout.js, Login.js, Register.js y Dashboard.js
// mantengan cada uno su propia copia (el teal de marca dejaba de estar sincronizado
// si se editaba en un archivo y se olvidaba en otro).
export const COLORS = {
  teal: '#1ab8ab',
  darkTeal: '#427c78',
  charcoal: '#383e41',
  white: '#ffffff',
  pageBg: '#f7f8fa',
  // Rojo institucional para acciones destructivas — hoy usado en el botón sólido
  // de los modales de confirmación de borrado/cancelación (nunca en la fila,
  // ver src/components/RowActions.js, hallazgo de auditoría #07).
  danger: '#e74c3c',
};

export default COLORS;
